import { useState } from "react";
import { toast } from "sonner";
import { LockSimple } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/i18n";

export const EmailGate = ({ reportId, onUnlock, cta = "Show my full report" }) => {
  const [email, setEmail] = useState("");
  const { t } = useT();
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!consent) { toast.error(t("Please tick the consent box to continue.")); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/tools/unlock", { email, report_id: reportId, consent });
      onUnlock(data.result);
      toast.success(t("Report unlocked."));
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="rounded-2xl border border-dashed border-[#0F4C5C]/40 bg-white p-6" data-testid="email-gate-form">
      <div className="flex items-center gap-2 text-[#0F4C5C] font-semibold"><LockSimple size={18} weight="duotone" /> {t("Get the full result by email")}</div>
      <p className="text-sm text-gray-600 mt-1">{t("Free. Includes the details for every fix and a rewritten example. One email a week, unsubscribe any time.")}</p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" placeholder="you@yourrental.com" data-testid="email-gate-input" />
        <button disabled={busy} className="btn-coral justify-center shrink-0" data-testid="email-gate-submit-btn">{busy ? t("Unlocking…") : t(cta)}</button>
      </div>
      <label className="mt-3 flex items-start gap-2 text-xs text-gray-600 cursor-pointer">
        <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-[#0F4C5C]" data-testid="email-gate-consent-checkbox" />
        {t("I agree to receive the HostScribe host letter. We confirm by email first (double opt-in). See our Privacy policy.")}
      </label>
    </form>
  );
};
